export interface AppealResolution {
  comment: string;
}
